export const maskConfigConstants = {

    pathKey: 'path',
    maskCharacterKey: 'maskCharacter',
    ccNumberFieldKey: 'ccNumberField',
    unmaskedLastDigitsLengthKey: 'unmaskedLastDigitsLength',
    lengthKey: 'length'

};
